<div class="pl-s pr-s pt-xs pb-xs bb-grey">
  <pagination-search [secondary]="'roomsList'" (callback)="reloadRooms()"></pagination-search>
</div>

<div class="am-flex-column am-flex-1 overflow-auto bg-grey">
  @for (room of sortedRooms(); track room; let i = $index) {
    <chats-list-item [room]="room"
                     [class.bt-grey]="i"
                     [isActive]="room.active"
                     [menuUp]="i >= 8"
                     (openRoom)="openRoom.emit(room)"
                     (leaveRoom)="reloadRooms(meta?.current_page)">
    </chats-list-item>
  }
</div>

@if (meta && meta.total_pages > 1) {
  <div class="p-s bt-grey">
    <pagination-secondary [totalPages]="meta.total_pages" [page]="meta.current_page" [total]="meta.total_count" [perPage]="meta.per_page" (callback)="reloadRooms($event)"></pagination-secondary>
  </div>
}
@if (loading) {
  <div class="absolute-full bg-overlay-white events-none wait-animation">
    <div class="am-flex-center">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}
